// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.multifamily.disclaimer.RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteMultifamilyListingFeeDisclaimerRequestDto } from '../..';

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/fees/multifamily/disclaimer/delete';

/**
 * Deletes a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete = (
  postData: DeleteMultifamilyListingFeeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteMultifamilyListingFeeDisclaimerRequestDto, void>(
    {
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
